const BLOCKED_ELEMENTS = 'script, noscript, iframe, object, embed, link, meta, base, form, input, button, textarea, select';
const URL_ATTRIBUTES = new Set(['href', 'src', 'xlink:href', 'action', 'formaction']);

const isSafeUrl = (value: string, attribute: string) => {
  const trimmed = value.trim();
  if (!trimmed || trimmed.startsWith('#') || trimmed.startsWith('/')) return true;
  if (attribute === 'src' && /^data:image\/(png|gif|jpeg|jpg|webp);base64,/i.test(trimmed)) return true;

  try {
    const parsed = new URL(trimmed, window.location.origin);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export const sanitizeHtml = (html: string) => {
  if (!html || typeof window === 'undefined') return '';

  const documentFragment = new DOMParser().parseFromString(html, 'text/html');
  documentFragment.querySelectorAll(BLOCKED_ELEMENTS).forEach(element => element.remove());
  documentFragment.querySelectorAll('img[src*="discord.com/assets/"]').forEach(element => element.remove());

  documentFragment.body.querySelectorAll<HTMLElement>('*').forEach(element => {
    [...element.attributes].forEach(attribute => {
      const name = attribute.name.toLowerCase();
      const value = attribute.value;

      if (name.startsWith('on') || name === 'srcdoc') {
        element.removeAttribute(attribute.name);
        return;
      }

      if (URL_ATTRIBUTES.has(name) && !isSafeUrl(value, name)) {
        element.removeAttribute(attribute.name);
        return;
      }

      if (name === 'style' && /(url\s*\(|expression\s*\(|@import|javascript:|behavior\s*:)/i.test(value)) {
        element.removeAttribute(attribute.name);
      }
    });

    if (element instanceof HTMLAnchorElement && element.target === '_blank') {
      element.rel = 'noopener noreferrer';
    }

    if (element instanceof HTMLImageElement) {
      if (!element.hasAttribute('alt')) element.alt = '';
      element.loading = 'lazy';
      element.decoding = 'async';
    }
  });

  return documentFragment.body.innerHTML;
};
